import React from "react";
import Slider from "react-slick";
import "./FreeTrialSection.css";
import trialImage from "../Assets/aboutfreetrial.png"; // Update path
import patternBg from "../Assets/Triangle.png"; // Update path

const AboutFreeTrialSection = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  return (
    <div className="free-trial-section">
      {/* Desktop Layout */}
      <div className="free-trial-desktop">
        <div className="text-content blue-bg1">
          <h2>Join Our Program and Level Up Your English</h2>
          <p>
          At NewZeal Language Academy, English learning is designed for everyone — from students preparing for exams, to professionals cracking interviews & advancing their careers, entrepreneurs expanding globally, and homemakers to communicate with ease. Whatever your goal, our flexible courses adapt to your needs and schedule.
          </p>
          <p>
         With expert teachers, interactive lessons, and real-world practice, you’ll build the confidence to speak and understand English in any setting — classrooms, workplaces, job interviews, business meetings, client calls, or social conversations. 
          </p>
          <p>
Our certificate courses not only sharpen your skills but also give you credentials that stand out in academics, careers, and global opportunities. </p>
<p>Don’t wait to move forward. Begin your journey today with NewZeal Language Academy — where skilled teachers, practical learning, and supportive guidance help you master English, not just for now, but for life.</p>
        </div>
        <div className="image-content">
          <img src={trialImage} alt="Free Trial" className="main-img1" />
          <img src={patternBg} alt="" className="pattern-bg" />
        </div>
      </div>

      {/* Mobile Slider */}
      <div className="free-trial-mobile">
        <Slider {...sliderSettings}>
          <div>
            <div className="text-content blue-bg">
              <h2>Free Trial & Affordable Learning</h2>
              <p>
                We understand that choosing an English course is a commitment.
                That's why we offer a free trial class so you can experience our
                teaching style before enrolling. Our plans are affordable and
                flexible, making it easier for you to start learning without
                financial stress.
              </p>
              <p>
                If you're just starting and want to learn English online for
                free, our blog and resource library also provide useful tips,
                exercises, and self-learning materials.
              </p>
            </div>
          </div>
          <div>
            <div className="image-content">
              <img src={trialImage} alt="Free Trial" className="main-img" />
              <img src={patternBg} alt="" className="pattern-bg" />
            </div>
          </div>
        </Slider>
      </div>
    </div>
  );
};

export default AboutFreeTrialSection;
